import { ActivationComponentAssets } from "app/pages/activation/helpers/ActivationAssets";
import { useShortActivationSetListQuery } from "app/pages/activation/queries/data/useShortActivationSetListQuery";
import type { ShortActivationSetSchema } from "app/pages/activation/types/api";

const useActivationQueryWithAccessControl = (
    customSelect?: (data: ShortActivationSetSchema[]) => ShortActivationSetSchema[],
) => useShortActivationSetListQuery(customSelect, !ActivationComponentAssets.isDisabled);

export default useActivationQueryWithAccessControl;
